module.exports = __webpack_public_path__ + "img/weWoman.720a58be.png";